import React from 'react';
import {
    annualizedOperatingData,
    getAnnualizedOperatingData,
    getLeaseSummaryData,
    getNetOperatingIncomeData,
    getOfferingSummaryData,
    leaseSummary,
    netOperatingIncome,
    offeringSummary
} from "./tables";

let cloneDeep = require('lodash.clonedeep');

export default class PrintSingleTenant extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                offeringSummary: offeringSummary,
                leaseSummary: leaseSummary,
                annualizedOperatingData: annualizedOperatingData,
                netOperatingIncome: netOperatingIncome
            }
        }
    }

    async componentWillReceiveProps(nextProps) {
        const data = cloneDeep(this.state.data);

        data.offeringSummary.rows = getOfferingSummaryData(nextProps.tables);
        data.leaseSummary.rows = getLeaseSummaryData(nextProps.tables);
        data.annualizedOperatingData.rows = getAnnualizedOperatingData(nextProps.tables);
        data.netOperatingIncome.value = getNetOperatingIncomeData(nextProps.tables);

        this.setState({data});
    }

    static renderTableMatrix(table) {
        return (
            <div className='PrintSingleTenant_content_table'>
                <div className='PrintSingleTenant_content_table_title'>{table.name}</div>
                {table.header ?
                    <div className='PrintSingleTenant_content_table_row'>
                        {table.header.map(cell => {
                            return (
                                <div key={cell} className='PrintSingleTenant_content_table_row_cell'>{cell}</div>
                            )
                        })}
                    </div>
                    : null
                }
                {table.rows.map((row, index) => {
                    return (
                        <div key={index} className={`PrintSingleTenant_content_table_row ${index % 2 !== 0 ? '' : 'white'}`}>
                            {row.valueCells.map((cell, cellIndex) => {
                                return (
                                    <div key={`${index}-${cellIndex}`} className='PrintSingleTenant_content_table_row_cell'>{cell.value}</div>
                                )
                            })}
                        </div>
                    )
                })}
            </div>
        )
    }

    static renderTable(table) {
        return (
            <div className={`PrintSingleTenant_content_table ${table.value ? 'no-margin' : ''}`}>
                {table.value ?
                    <div className='PrintSingleTenant_content_table_one_row'>
                        <div className='PrintSingleTenant_content_table_title'>{table.name}</div>
                        <div className='PrintSingleTenant_content_table_value'>{table.value}</div>
                    </div>
                    :
                    <div className='PrintSingleTenant_content_table_title'>{table.name}</div>
                }
                {table.rows ?
                    table.rows.map((row, index) => {
                        return (
                            <div key={index} className={`PrintSingleTenant_content_table_column ${index % 2 !== 0 ? 'white' : ''}`}>
                                <div>{row.label}</div>
                                <div>{row.value}</div>
                            </div>
                        )
                    })
                    : null
                }
            </div>
        );
    }

    render() {
        const data = this.state.data;
        const agents = this.props.agents;
        const name = this.props.tables['general-information'].rows['property-name'].value;
        const address = this.props.tables['general-information'].rows['address'].value;
        const city = this.props.tables['general-information'].rows['city'].value;
        const state = this.props.tables['general-information'].rows['state'].value;
        const zip = this.props.tables['general-information'].rows['zip'].value;
        const photo = arc.path.media + this.props.propertyImage;

        return (
            <div className='PrintSingleTenant' style={{backgroundImage: `url('${arc.path.media+'stnl-background.png'}')`}}>
                <div className='PrintSingleTenant_head'>
                    <div className='PrintSingleTenant_head_logo'>
                        <img src={arc.path.media+'strive-logo.png'} alt=''/>
                    </div>
                </div>
                <div className='PrintSingleTenant_content'>
                    <div className='PrintSingleTenant_content_left'>
                        <div className='PrintSingleTenant_content_name'>{name}</div>
                        <div className='PrintSingleTenant_content_address'>{address}</div>
                        <div className='PrintSingleTenant_content_address'>{`${city}, ${state} ${zip}`}</div>
                        {PrintSingleTenant.renderTable(data.offeringSummary)}
                        {PrintSingleTenant.renderTable(data.leaseSummary)}
                    </div>
                    <div className='PrintSingleTenant_content_right'>
                        {this.props.propertyImage ?
                            <div className='PrintSingleTenant_content_image'>
                                <img src={photo} alt=''/>
                            </div>
                            :
                            null
                        }
                        {PrintSingleTenant.renderTableMatrix(data.annualizedOperatingData)}
                        {PrintSingleTenant.renderTable(data.netOperatingIncome)}
                    </div>
                </div>
                <div className='PrintSingleTenant_footer'>
                    {agents && agents.length ?
                        agents.map(agent => {
                            return (
                                <div key={agent.id}>
                                    <div className='PrintSingleTenant_footer_name'>{agent.name}</div>
                                    <div className='PrintSingleTenant_footer_details'>
                                        <div>{agent.phone}</div>
                                        <div className='PrintSingleTenant_footer_line'/>
                                        <div>{agent.email}</div>
                                    </div>
                                </div>
                            )
                        }) : null
                    }
                </div>
            </div>
        )
    }
}